import React, { useEffect, useMemo, useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import {
  Building2,
  ExternalLink,
  Filter,
  Globe,
  Hospital as HospitalIcon,
  Phone,
  Search,
  Users,
} from "lucide-react";
import "../styles/Hospital.css";

const a = "/img/Western Peaks Specialty Hospital.webp";
const b = "/img/Valley View Medical Center.webp";
const c = "/img/Utah Valley Specialty Hospital.webp";
const d = "/img/Utah Valley Hospital.webp";
const e = "/img/Utah State Hospital.webp";
const f = "/img/University of Utah Hospital.webp";
const g = "/img/Uintah Basin Medical Center.webp";
const h = "/img/Timpanogos Regional Hospital.webp";
const i = "/img/The Orthopedic Specialty Clinic at TOSH.png";
const j = "/img/St. George Regional Hospital.webp";
const k = "/img/Spanish Fork Hospital.webp";
const l = "/img/Shriners Hospitals for Children.webp";
const m = "/img/Sevier Valley Hospital.webp";
const n = "/img/Sanpete Valley Hospital.webp";
const o = "/img/San Juan Hospital.webp";
const p = "/img/Salt Lake Specialty Hospital.webp";
const q = "/img/Salt Lake Behavioral Health Hospital.webp";
const r = "/img/Saint Mark's Hospital.webp";
const s = "/img/Riverton Hospital.webp";
const t = "/img/Primary Children's Hospital.webp";
const u = "/img/Park City Hospital.webp";
const v = "/img/Orem Community Hospital.webp";
const w = "/img/Ogden Regional Medical Center.webp";
const x = "/img/Northern Utah Rehabilitation Hospital.webp";
const y = "/img/Mountain West Medical Center.webp";
const z = "/img/Mountain View Hospital - Payson.webp";
const a1 = "/img/Moab Regional Hospital.webp";
const b1 = "/img/McKay-Dee Hospital.webp";
const c1 = "/img/Marian Center_St. Joseph's Villa of SLC.png";
const d1 = "/img/Lone Peak Hospital.webp";
const e1 = "/img/Logan Regional Hospital.webp";
const f1 = "/img/LDS Hospital.webp";
const g1 = "/img/Layton Hospital.webp";
const h1 = "/img/Lakeview Hospital.webp";
const i1 = "/img/Kane County Human Resource SSD (Hospital).webp";
const j1 = "/img/Intermountain Medical Center.webp";
const k1 = "/img/Huntsman Mental Health Institute.webp";
const l1 = "/img/Huntsman Cancer Institute.png";
const m1 = "/img/Heber Valley Medical Center.webp";
const n1 = "/img/Gunnison Valley Hospital.webp";
const o1 =
  "/img/George E. Wahlen Department of Veterans Affairs Medical Center.webp";
const p1 = "/img/Garfield Memorial Hospital Utah.webp";
const q1 = "/img/Fillmore Community Medical Center.webp";
const r1 = "/img/Encompass Health Rehabilitation Hospital.webp";
const s1 = "/img/Delta Community Medical Center.webp";
const t1 = "/img/CommonSpirit-Holy Cross Hospital-Salt Lake.webp";
const u1 = "/img/CommonSpirit-Holy Cross Hospital-Jordan Valley Utah.webp";
const v1 = "/img/CommonSpirit-Holy Cross Hospital-Davis.webp";
const w1 = "/img/CommonSpirit-Holy Cross Hospital - Mountain Point.webp";
const x1 = "/img/Common Spirit-Holy Cross Hospital-Jordan Valley West.webp";
const y1 = "/img/Central Valley Medical Center.webp";
const z1 = "/img/Center for Change .png";
const a2 = "/img/Cedar City Hospital.webp";
const b2 = "/img/Castleview Hospital.webp";
const c2 = "/img/Cache Valley Hospital.webp";
const d2 = "/img/Brigham City Community Hospital.webp";
const e2 = "/img/Blue Mountain Hospital.webp";
const f2 = "/img/Benchmark Behavioral Health Systems North.webp";
const g2 = "/img/Beaver Valley Hospital.webp";
const h2 = "/img/Bear River Valley Hospital.webp";
const i2 = "/img/Aspen Grove Behavioral Hospital.webp";
const j2 = "/img/Ashley Regional Medical Center.webp";
const k2 = "/img/American Fork Hospital.webp";
const l2 = "/img/Alta View Hospital.webp";
const HOSPITALS_PER_PAGE = 12;

const Hospital = () => {
  const hospitals = [
    {
      "Hospital Name": "Alta View Hospital",
      City: "Sandy",
      Address: "9660 S 1300 E, Sandy, UT 84094",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801) 501-2600",
      Beds: "57",
      Website:
        "https://intermountainhealthcare.org/locations/alta-view-hospital",
      Image: l2,
    },
    {
      "Hospital Name": "American Fork Hospital",
      City: "American Fork",
      Address: "170 N 1100 E, American Fork, UT 84003",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801) 855-3300",
      Beds: "90",
      Website:
        "https://intermountainhealthcare.org/locations/american-fork-hospital",
      Image: k2,
    },
    {
      "Hospital Name": "Ashley Regional Medical Center",
      City: "Vernal",
      Address: "150 W 100 N, Vernal, UT 84078",
      Owner: "LifePoint Hospitals",
      "Phone No:": "(435) 789-3342",
      Beds: "39",
      Website: "https://www.ashleyregional.com",
      Image: j2,
    },
    {
      "Hospital Name": "Aspen Grove Behavioral Hospital",
      City: "Orem",
      Address: "1350 E 750 N St, Orem, UT 84097",
      Owner: "Independent (UHS)",
      "Phone No:": "(801)-852-2273",
      Beds: "80",
      Website: "https://aspengrovehospital.com",
      Image: i2,
    },
    {
      "Hospital Name": "Bear River Valley Hospital",
      City: "Tremonton",
      Address: "905 N 1000 W, Tremonton, UT 84337",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435)-207-4671",
      Beds: "16",
      Website:
        "https://intermountainhealthcare.org/locations/bear-river-valley-hospital",
      Image: h2,
    },
    {
      "Hospital Name": "Beaver Valley Hospital",
      City: "Beaver",
      Address: "1109 N 100 W St, Beaver, UT 84713",
      Owner: "City of Beaver",
      "Phone No:": "(435)-438-7100",
      Beds: "49",
      Website: "https://beaverutah.net/community/beaver-valley-hospital/",
      Image: g2,
    },
    {
      "Hospital Name": "Benchmark Behavioral Health Systems North",
      City: "Woods Cross",
      Address: "592 W 1350 S,Woods Cross, UT 84010",
      Owner: "Independent (Psychiatric Solutions)",
      "Phone No:": "(801) 299-5300",
      Beds: "84",
      Website: "https://bbhsnet.com",
      Image: f2,
    },
    {
      "Hospital Name": "Blue Mountain Hospital",
      City: "Blanding",
      Address: "802 S 200 W, Blanding, UT 84511",
      Owner: "Blue Mountain Hospital, Inc.",
      "Phone No:": "(435)-678-3993",
      Beds: "11",
      Website: "https://www.bmhutah.org",
      Image: e2,
    },
    {
      "Hospital Name": "Brigham City Community Hospital",
      City: "Brigham City",
      Address: "950 Medical Dr, Brigham City, UT 84302",
      Owner: "MountainStar Healthcare",
      "Phone No:": "(435) 734-9471",
      Beds: "49",
      Website:
        "https://www.mountainstar.com/locations/brigham-city-community-hospital",
      Image: d2,
    },
    {
      "Hospital Name": "Cache Valley Hospital",
      City: "North Logan",
      Address: "2380 N 400 E, North Logan, UT 84341",
      Owner: "MountainStar Healthcare",
      "Phone No:": "(435) 713-9700",
      Beds: "28",
      Website: "https://www.mountainstar.com/locations/cache-valley-hospital",
      Image: c2,
    },
    {
      "Hospital Name": "Castleview Hospital",
      City: "Price",
      Address: "300 Hospital Dr, Price, UT 84501",
      Owner: "LifePoint Hospitals",
      "Phone No:": "(435) 637-4800",
      Beds: "39",
      Website: "https://www.castleviewhospital.net",
      Image: b2,
    },
    {
      "Hospital Name": "Cedar City Hospital",
      City: "Cedar City",
      Address: "1303 N Main St, Cedar City, UT 84721",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435)-868-5000",
      Beds: "48",
      Website:
        "https://intermountainhealthcare.org/locations/cedar-city-hospital",
      Image: a2,
    },
    {
      "Hospital Name": "Central Valley Medical Center",
      City: "Nephi",
      Address: "48 W 1500 N, Nephi, UT 84648",
      Owner: "Juab County",
      "Phone No:": "(435)-623-3000",
      Beds: "17",
      Website:
        "https://www.centralvalleymedicalcenter.com/locations/central-valley-medical-center/",
      Image: y1,
    },
    {
      "Hospital Name": "Center for Change ",
      City: "Orem",
      Address: "1790 N State St, Orem, UT 84057",
      Owner: "Independent (Universal Health Services, Inc.)",
      "Phone No:": "(801) 224-8255",
      Beds: "58",
      Website: "https://centerforchange.com",
      Image: z1,
    },
    {
      "Hospital Name": "Common Spirit-Holy Cross Hospital-Jordan Valley West",
      City: "West Valley City",
      Address: "3460 S 4155 W, West Valley City, UT 84120",
      Owner: "CommonSpirit Health",
      "Phone No:": "(801) 964-3100",
      Beds: "102",
      Website:
        "https://www.mountain.commonspirit.org/location/holy-cross-hospital-west-valley",
      Image: x1,
    },
    {
      "Hospital Name": "CommonSpirit - Holy Cross Hospital - Mountain Point",
      City: "Lehi",
      Address: "3000 Triumph Blvd, Lehi, UT 84043",
      Owner: "CommonSpirit Health",
      "Phone No:": "(385) 345-3000",
      Beds: "40",
      Website:
        "https://www.mountain.commonspirit.org/location/holy-cross-hospital-mountain-point",
      Image: w1,
    },
    {
      "Hospital Name": "CommonSpirit - Holy Cross Hospital - Salt Lake",
      City: "Salt Lake City",
      Address: "1050 E S Temple St, Salt Lake City, UT 84102",
      Owner: "CommonSpirit Health",
      "Phone No:": "(801) 350-4111",
      Beds: "158",
      Website:
        "https://www.mountain.commonspirit.org/location/holy-cross-hospital-salt-lake",
      Image: v1,
    },
    {
      "Hospital Name": "CommonSpirit-Holy Cross Hospital-Davis",
      City: "Layton",
      Address: "1600 W Antelope Dr, Layton, UT 84041",
      Owner: "CommonSpirit Health",
      "Phone No:": "(801) 807-1000",
      Beds: "220",
      Website:
        "https://www.mountain.commonspirit.org/location/holy-cross-hospital-davis",
      Image: u1,
    },
    {
      "Hospital Name": "CommonSpirit-Holy Cross Hospital-Jordan Valley",
      City: "West Jordan",
      Address: "3580 W 9000 S, West Jordan, UT 84088",
      Owner: "CommonSpirit Health",
      "Phone No:": "(801) 561-8888",
      Beds: "193",
      Website:
        "https://www.mountain.commonspirit.org/location/holy-cross-hospital-jordan-valley",
      Image: t1,
    },
    {
      "Hospital Name": "Delta Community Medical Center",
      City: "Delta",
      Address: "126 White Sage Ave, Delta, UT 84624",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435) 864-5591",
      Beds: "17",
      Website:
        "https://intermountainhealthcare.org/locations/delta-community-hospital",
      Image: s1,
    },
    {
      "Hospital Name": "Encompass Health Rehabilitation Hospital",
      City: "Sandy",
      Address: "8074 S 1300 E, Sandy, UT 84094",
      Owner: "Encompass Health",
      "Phone No:": "(801) 561-3400",
      Beds: "84",
      Website: "https://encompasshealth.com",
      Image: r1,
    },
    {
      "Hospital Name": "Fillmore Community Medical Center",
      City: "Fillmore",
      Address: "674 UT-99, Fillmore, UT 84631",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435) 743-5591",
      Beds: "18",
      Website:
        "https://intermountainhealthcare.org/locations/fillmore-community-hospital",
      Image: q1,
    },
    {
      "Hospital Name": "Garfield Memorial Hospital",
      City: "Panguitch",
      Address: "200 N 400 E St, Panguitch, UT 84759",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435) 676-8811",
      Beds: "41",
      Website:
        "https://intermountainhealthcare.org/locations/garfield-memorial-hospital",
      Image: p1,
    },
    {
      "Hospital Name": "Gunnison Valley Hospital",
      City: "Gunnison",
      Address: "64 E 100 N St, Gunnison, UT 84634",
      Owner: "Independent",
      "Phone No:": "(435)-528-7246",
      Beds: "24",
      Website: "https://www.gvhospital.org",
      Image: n1,
    },
    {
      "Hospital Name": "Heber Valley Medical Center",
      City: "Heber",
      Address: "454 East Medical Way, Heber City, UT 84032",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435) 654-2500",
      Beds: "19",
      Website:
        "https://intermountainhealthcare.org/locations/heber-valley-hospital",
      Image: m1,
    },
    {
      "Hospital Name": "Huntsman Cancer Institute",
      City: "Salt Lake City",
      Address: "2000 Cir of Hope Dr, Salt Lake City, UT 84112",
      Owner: "University of Utah",
      "Phone No:": "(801)-587-7000",
      Beds: "48",
      Website: "https://healthcare.utah.edu/huntsmancancerinstitute/",
      Image: l1,
    },
    {
      "Hospital Name": "Huntsman Mental Health Institute",
      City: "Salt Lake City",
      Address: "501 Chipeta Way, Salt Lake City, UT 84108",
      Owner: "University of Utah",
      "Phone No:": "(801) 583-2500",
      Beds: "170",
      Website: "https://healthcare.utah.edu/locations/hmhi",
      Image: k1,
    },
    {
      "Hospital Name":
        "George E. Wahlen Department of Veterans Affairs Medical Center",
      City: "Salt Lake City",
      Address: "500 Foothill Dr, Salt Lake City, UT 84148",
      Owner: "University of Utah",
      "Phone No:": "(801)-582-1565",
      Beds: "121",
      Website: "https://www.va.gov/salt-lake-city-health-care/",
      Image: o1,
    },
    {
      "Hospital Name": "Intermountain Medical Center",
      City: "Murray",
      Address: "5121 Cottonwood St, Murray, UT 84107",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801)-507-7000",
      Beds: "504",
      Website:
        "https://intermountainhealthcare.org/locations/intermountain-medical-center",
      Image: j1,
    },
    {
      "Hospital Name": "Kane County Human Resource SSD (Hospital)",
      City: "Kanab",
      Address: "355 NORTH MAIN KANAB, UT 84741",
      Owner: "Special Service District of the State of Utah",
      "Phone No:": "(435)-644-5811",
      Beds: "38",
      Website:
        "https://kchosp.net/announcements/2017/kane-county-human-resources-special-service-district/",
      Image: i1,
    },
    {
      "Hospital Name": "Lakeview Hospital",
      City: "Bountiful",
      Address: "630 Medical Dr, Bountiful, UT 84010",
      Owner: "MountainStar Healthcare",
      "Phone No:": "(801) 299-2200",
      Beds: "128",
      Website: "https://www.mountainstar.com/locations/lakeview-hospital",
      Image: h1,
    },
    {
      "Hospital Name": "Layton Hospital",
      City: "Layton",
      Address: "201 W Layton Pkwy, Layton, UT 84041",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801) 543-6000",
      Beds: "43",
      Website: "https://intermountainhealthcare.org/locations/layton-hospital",
      Image: g1,
    },
    {
      "Hospital Name": "LDS Hospital",
      City: "Salt Lake City",
      Address: "8th Ave, C St E, Salt Lake City, UT 84143",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801) 408-1100",
      Beds: "262",
      Website: "https://intermountainhealthcare.org/locations/lds-hospital",
      Image: f1,
    },
    {
      "Hospital Name": "Logan Regional Hospital",
      City: "Logan",
      Address: "1400 N 500 E, Logan, UT 84341",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435)-716-2240",
      Beds: "148",
      Website:
        "https://intermountainhealthcare.org/locations/logan-regional-hospital",
      Image: e1,
    },
    {
      "Hospital Name": "Lone Peak Hospital",
      City: "Draper",
      Address: "11925 State St, Draper, UT 84020",
      Owner: "MountainStar Healthcare",
      "Phone No:": "(801) 545-8000",
      Beds: "61",
      Website: "https://www.mountainstar.com/locations/lone-peak-hospital",
      Image: d1,
    },
    {
      "Hospital Name": "Marian Center/St. Joseph's Villa of SLC",
      City: "Salt Lake City",
      Address: "451 Bishop Federal Ln, Salt Lake City, UT 84115",
      Owner: "Independent (St Joseph's)",
      "Phone No:": "(801)-468-6856",
      Beds: "14",
      Website: "https://themariancenter.net",
      Image: c1,
    },
    {
      "Hospital Name": "McKay-Dee Hospital",
      City: "Ogden",
      Address: "4401 Harrison Blvd, Ogden, UT 84403",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801) 627-2800",
      Beds: "310",
      Website:
        "https://intermountainhealthcare.org/locations/mckay-dee-hospital",
      Image: b1,
    },
    {
      "Hospital Name": "Moab Regional Hospital",
      City: "Moab",
      Address: "450 Williams Way, Moab, UT 84532",
      Owner: "Independent",
      "Phone No:": "(435)-210-6860",
      Beds: "17",
      Website: "https://mrhmoab.org",
      Image: a1,
    },
    {
      "Hospital Name": "Mountain View Hospital - Payson",
      City: "Payson",
      Address: "1000 E 100 N, Payson, UT 84651",
      Owner: "MountainStar Healthcare",
      "Phone No:": "(801) 465-9201",
      Beds: "124",
      Website:
        "https://www.mountainstar.com/locations/mountain-view-hospital-payson",
      Image: z,
    },
    {
      "Hospital Name": "Mountain West Medical Center",
      City: "Tooele",
      Address: "2055 N Main St, Tooele, UT 84074",
      Owner: "Independent (Quorum Health)",
      "Phone No:": "(435) 843-3600",
      Beds: "44",
      Website: "https://mountainwestmc.com",
      Image: y,
    },
    {
      "Hospital Name": "Northern Utah Rehabilitation Hospital",
      City: "South Ogden",
      Address: "5825 Harrison Blvd, South Ogden, UT 84403",
      Owner: "Independent (Ernest Health)",
      "Phone No:": "(801) 475-5254",
      Beds: "40",
      Website: "https://nurh.ernesthealth.com",
      Image: x,
    },
    {
      "Hospital Name": "Ogden Regional Medical Center",
      City: "Ogden",
      Address: "5475 S 500 E, Ogden, UT 84405",
      Owner: "MountainStar Healthcare",
      "Phone No:": "(801) 479-2111",
      Beds: "238",
      Website:
        "https://www.mountainstar.com/locations/ogden-regional-medical-center",
      Image: w,
    },
    {
      "Hospital Name": "Orem Community Hospital",
      City: "Orem",
      Address: "331 N 400 W St, Orem, UT 84057",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801) 224-4080",
      Beds: "18",
      Website:
        "https://intermountainhealthcare.org/locations/orem-community-hospital",
      Image: v,
    },
    {
      "Hospital Name": "Park City Hospital",
      City: "Park City",
      Address: "900 Round Valley Dr, Park City, UT 84060",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435) 658-7000",
      Beds: "37",
      Website:
        "https://intermountainhealthcare.org/locations/park-city-hospital",
      Image: u,
    },
    {
      "Hospital Name": "Primary Children's Hospital",
      City: "Salt Lake City",
      Address: "100 Mario Capecchi Dr, Salt Lake City, UT 84113",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801) 662-1000",
      Beds: "289",
      Website:
        "https://intermountainhealthcare.org/locations/primary-childrens-salt-lake-city",
      Image: t,
    },
    {
      "Hospital Name": "Riverton Hospital",
      City: "Riverton",
      Address: "3741 W 12600 S, Riverton, UT 84065",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801) 285-4000",
      Beds: "97",
      Website:
        "https://intermountainhealthcare.org/locations/riverton-hospital",
      Image: s,
    },
    {
      "Hospital Name": "St. George Regional Hospital",
      City: "St. George",
      Address: "1380 E Medical Center Dr, St. George, UT 84790",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435) 251-1000",
      Beds: "284",
      Website:
        "https://intermountainhealthcare.org/locations/st-george-regional-hospital",
      Image: j,
    },
    {
      "Hospital Name": "Saint Mark's Hospital",
      City: "Salt Lake City",
      Address: "1200 E 3900 S, Millcreek, UT 84124",
      Owner: "MountainStar Healthcare",
      "Phone No:": "(801) 268-7111",
      Beds: "325",
      Website: "https://www.mountainstar.com/locations/st-marks-hospital",
      Image: r,
    },
    {
      "Hospital Name": "Salt Lake Behavioral Health Hospital",
      City: "South Salt Lake",
      Address: "3802 S 700 E, Salt Lake City, UT 84106",
      Owner: "Universal Health Services",
      "Phone No:": "(801) 264-6000",
      Beds: "118",
      Website: "https://saltlakebehavioralhealth.com",
      Image: q,
    },
    {
      "Hospital Name": "Salt Lake Specialty Hospital",
      City: "Murray",
      Address: "4252 Birkhill Blvd, Murray, UT 84107",
      Owner: "Salt Lake Specialty Hospital",
      "Phone No:": "(385) 425-0050",
      Beds: "38",
      Website: "https://slspecialty.org",
      Image: p,
    },
    {
      "Hospital Name": "San Juan Hospital",
      City: "Monticello",
      Address: "380 W 100 N, Monticello, UT 84535",
      Owner: "Independent",
      "Phone No:": "(435)-587-2116",
      Beds: "198",
      Website: "https://sanjuanhealth.org",
      Image: o,
    },
    {
      "Hospital Name": "Sanpete Valley Hospital",
      City: "Mt. Pleasant",
      Address: "1100 S Medical Dr, Mt Pleasant, UT 84647",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435) 462-2441",
      Beds: "18",
      Website:
        "https://intermountainhealthcare.org/locations/sanpete-valley-hospital",
      Image: n,
    },
    {
      "Hospital Name": "Sevier Valley Hospital",
      City: "Richfield",
      Address: "1000 N Main St, Richfield, UT 84701",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435) 893-4100",
      Beds: "24",
      Website:
        "https://intermountainhealthcare.org/locations/sevier-valley-hospital",
      Image: m,
    },
    {
      "Hospital Name": "Shriners Hospitals for Children",
      City: "Salt Lake City",
      Address: "1275 E Fairfax Rd, Salt Lake City, UT 84103",
      Owner: "Shriners Hospitals for Children",
      "Phone No:": "(801)-536-3500",
      Beds: "40",
      Website: "https://www.shrinerschildrens.org/en/locations/salt-lake-city",
      Image: l,
    },
    {
      "Hospital Name": "Spanish Fork Hospital",
      City: "Spanish Fork",
      Address: "765 E Mkt Pl Dr, Spanish Fork, UT 84660",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(385) 344-5000",
      Beds: "33",
      Website:
        "https://intermountainhealthcare.org/locations/spanish-fork-hospital",
      Image: k,
    },
    {
      "Hospital Name": "The Orthopedic Specialty Clinic at TOSH",
      City: "Murray",
      Address: "5848 Fashion Boulevard, Suite 110. Murray, UT 84107",
      Owner: "Independent",
      "Phone No:": "(801) 314-4188",
      Beds: "14",
      Website: "https://www.toshmd.com",
      Image: i,
    },
    {
      "Hospital Name": "Timpanogos Regional Hospital",
      City: "Orem",
      Address: "750 W 800 N, Orem, UT 84057",
      Owner: "MountainStar Healthcare",
      "Phone No:": "(801) 714-6000",
      Beds: "122",
      Website:
        "https://www.mountainstar.com/locations/timpanogos-regional-hospital",
      Image: h,
    },
    {
      "Hospital Name": "Uintah Basin Medical Center",
      City: "Roosevelt",
      Address: "250 W 300 N, Roosevelt, UT 84066",
      Owner: "Independent",
      "Phone No:": "(435)-722-4691",
      Beds: "42",
      Website: "https://ubh.org",
      Image: g,
    },
    {
      "Hospital Name": "University of Utah Hospital",
      City: "Salt Lake City",
      Address: "50 Medical Dr N, Salt Lake City, UT 84132",
      Owner: "University of Utah",
      "Phone No:": "(801) 581-2121",
      Beds: "425",
      Website: "https://healthcare.utah.edu/locations/hospital",
      Image: f,
    },
    {
      "Hospital Name": "Utah State Hospital",
      City: "Provo",
      Address: "1300 E Center St, Provo, UT 84606",
      Owner: "Utah Department of Human Services",
      "Phone No:": "(801) 344-4400",
      Beds: "324",
      Website: "https://ush.utah.gov",
      Image: e,
    },
    {
      "Hospital Name": "Utah Valley Hospital",
      City: "Provo",
      Address: "1034 No 500 W, Provo, UT 84604",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(801) 373-7850",
      Beds: "395",
      Website:
        "https://intermountainhealthcare.org/locations/utah-valley-hospital",
      Image: d,
    },
    {
      "Hospital Name": "Utah Valley Specialty Hospital",
      City: "Provo",
      Address: "306 W River Bend Ln, Provo, UT 84604",
      Owner: "Ernest Health",
      "Phone No:": "(801) 226-8880",
      Beds: "40",
      Website: "https://uvsh.ernesthealth.com",
      Image: c,
    },
    {
      "Hospital Name": "Valley View Medical Center",
      City: "Cedar City",
      Address: "1333 N Main St Suite 4/5, Cedar City, UT 84721",
      Owner: "Intermountain Healthcare",
      "Phone No:": "(435)-868-5566",
      Beds: "48",
      Website:
        "https://intermountainhealthcare.org/locations/valley-view-family-medicine",
      Image: b,
    },
    {
      "Hospital Name": "Western Peaks Specialty Hospital",
      City: "Bountiful",
      Address: "485 500 S, Bountiful, UT 84010",
      Owner: "Community",
      "Phone No:": "(801)-299-4800",
      Beds: "43",
      Website:
        "https://www.sdch.com/locations/western-peaks-specialty-hospital/",
      Image: a,
    },
  ];

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOwner, setSelectedOwner] = useState("All");
  const [selectedCity, setSelectedCity] = useState("All");
  const [selectedBedSize, setSelectedBedSize] = useState("All");
  const [sortBy, setSortBy] = useState("beds");
  const [currentPage, setCurrentPage] = useState(1);

  const hospitalsWithMetrics = useMemo(
    () =>
      hospitals.map((hospital) => {
        const beds = Number.parseInt(hospital.Beds, 10) || 0;
        let bedSize = "Small";

        if (beds >= 100) {
          bedSize = "Large";
        } else if (beds >= 40) {
          bedSize = "Medium";
        }

        return {
          ...hospital,
          beds,
          bedSize,
        };
      }),
    [hospitals]
  );

  const ownerOptions = useMemo(
    () =>
      ["All", ...new Set(hospitalsWithMetrics.map((hospital) => hospital.Owner))],
    [hospitalsWithMetrics]
  );

  const cityOptions = useMemo(
    () =>
      ["All", ...new Set(hospitalsWithMetrics.map((hospital) => hospital.City))].sort(
        (a, b) => a.localeCompare(b)
      ),
    [hospitalsWithMetrics]
  );

  const filteredHospitals = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();

    const filtered = hospitalsWithMetrics.filter((hospital) => {
      const matchesSearch = query
        ? [
            hospital["Hospital Name"],
            hospital.City,
            hospital.Owner,
            hospital.Address,
            hospital["Phone No:"],
          ]
            .filter(Boolean)
            .some((value) => value.toLowerCase().includes(query))
        : true;

      const matchesOwner =
        selectedOwner === "All" || hospital.Owner === selectedOwner;
      const matchesCity = selectedCity === "All" || hospital.City === selectedCity;
      const matchesBedSize =
        selectedBedSize === "All" || hospital.bedSize === selectedBedSize;

      return matchesSearch && matchesOwner && matchesCity && matchesBedSize;
    });

    return filtered.sort((a, b) => {
      if (sortBy === "name") {
        return a["Hospital Name"].localeCompare(b["Hospital Name"]);
      }

      if (sortBy === "city") {
        return a.City.localeCompare(b.City);
      }

      return b.beds - a.beds;
    });
  }, [
    hospitalsWithMetrics,
    searchQuery,
    selectedOwner,
    selectedCity,
    selectedBedSize,
    sortBy,
  ]);

  const totalBeds = useMemo(
    () => hospitalsWithMetrics.reduce((sum, hospital) => sum + hospital.beds, 0),
    [hospitalsWithMetrics]
  );

  const topCity = useMemo(() => {
    const counts = hospitalsWithMetrics.reduce((acc, hospital) => {
      acc[hospital.City] = (acc[hospital.City] || 0) + 1;
      return acc;
    }, {});

    const [city, count] = Object.entries(counts).sort((a, b) => b[1] - a[1])[0] || [
      "N/A",
      0,
    ];

    return { city, count };
  }, [hospitalsWithMetrics]);

  const ownerBreakdown = useMemo(() => {
    const counts = hospitalsWithMetrics.reduce((acc, hospital) => {
      acc[hospital.Owner] = (acc[hospital.Owner] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(counts)
      .map(([owner, count]) => ({ owner, count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 6);
  }, [hospitalsWithMetrics]);

  const cityBreakdown = useMemo(() => {
    const counts = hospitalsWithMetrics.reduce((acc, hospital) => {
      acc[hospital.City] = (acc[hospital.City] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(counts)
      .map(([city, count]) => ({ city, count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 6);
  }, [hospitalsWithMetrics]);

  const largestHospitals = useMemo(
    () => [...hospitalsWithMetrics].sort((a, b) => b.beds - a.beds).slice(0, 5),
    [hospitalsWithMetrics]
  );

  const totalPages = Math.max(
    1,
    Math.ceil(filteredHospitals.length / HOSPITALS_PER_PAGE)
  );

  const paginatedHospitals = useMemo(() => {
    const startIndex = (currentPage - 1) * HOSPITALS_PER_PAGE;
    return filteredHospitals.slice(startIndex, startIndex + HOSPITALS_PER_PAGE);
  }, [currentPage, filteredHospitals]);

  const visibleRangeStart =
    filteredHospitals.length === 0 ? 0 : (currentPage - 1) * HOSPITALS_PER_PAGE + 1;
  const visibleRangeEnd = Math.min(
    currentPage * HOSPITALS_PER_PAGE,
    filteredHospitals.length
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, selectedOwner, selectedCity, selectedBedSize, sortBy]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const maxOwnerCount = Math.max(...ownerBreakdown.map((item) => item.count), 1);
  const maxCityCount = Math.max(...cityBreakdown.map((item) => item.count), 1);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <div className="w-full">
        <LandingSection
          data={{
            imageName: "hospital1.webp",
            title: "Utah Hospitals",
            visible: "",
          }}
        />
      </div>

      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Utah Hospitals ({hospitals.length})</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah is home to a network of advanced hospitals and healthcare
              systems, offering high-quality medical services, research, and
              specialized care across urban and rural communities.
            </p>

            {/* <ActionButton data="Explore More" /> */}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-grow mx-auto py-12 w-full">
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
            Utah Hospitals
          </h1>
          <p className="text-xl text-blue-700">
            Explore hospitals by owner, city, bed size, and care footprint
          </p>
        </div>

        <div className="hospital-dashboard-shell">
          <section className="hospital-stats-grid">
            <article className="hospital-stat-card">
              <HospitalIcon size={24} />
              <div>
                <span className="hospital-stat-value">{hospitals.length}</span>
                <span className="hospital-stat-label">Total Hospitals</span>
              </div>
            </article>
            <article className="hospital-stat-card">
              <Users size={24} />
              <div>
                <span className="hospital-stat-value">
                  {totalBeds.toLocaleString()}
                </span>
                <span className="hospital-stat-label">Licensed Beds</span>
              </div>
            </article>
            <article className="hospital-stat-card">
              <Building2 size={24} />
              <div>
                <span className="hospital-stat-value">
                  {ownerOptions.length - 1}
                </span>
                <span className="hospital-stat-label">Owner Groups</span>
              </div>
            </article>
            <article className="hospital-stat-card">
              <Globe size={24} />
              <div>
                <span className="hospital-stat-value">{topCity.city}</span>
                <span className="hospital-stat-label">
                  Top City ({topCity.count})
                </span>
              </div>
            </article>
          </section>

          <section className="hospital-visual-grid">
            <article className="hospital-panel">
              <div className="hospital-panel-head">
                <h3>Leading Health Systems</h3>
                <p>Largest owner groups by hospital count</p>
              </div>
              <div className="hospital-bar-list">
                {ownerBreakdown.map((item) => (
                  <div key={item.owner} className="hospital-bar-row">
                    <div className="hospital-bar-copy">
                      <span>{item.owner}</span>
                      <strong>{item.count}</strong>
                    </div>
                    <div className="hospital-bar-track">
                      <div
                        className="hospital-bar-fill"
                        style={{
                          width: `${(item.count / maxOwnerCount) * 100}%`,
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </article>

            <article className="hospital-panel">
              <div className="hospital-panel-head">
                <h3>Most Concentrated Cities</h3>
                <p>Where hospital presence is most visible</p>
              </div>
              <div className="hospital-bar-list">
                {cityBreakdown.map((item) => (
                  <div key={item.city} className="hospital-bar-row">
                    <div className="hospital-bar-copy">
                      <span>{item.city}</span>
                      <strong>{item.count}</strong>
                    </div>
                    <div className="hospital-bar-track warm">
                      <div
                        className="hospital-bar-fill warm"
                        style={{
                          width: `${(item.count / maxCityCount) * 100}%`,
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </article>

            <article className="hospital-panel">
              <div className="hospital-panel-head">
                <h3>Largest by Beds</h3>
                <p>Top facilities by bed capacity</p>
              </div>
              <div className="hospital-top-list">
                {largestHospitals.map((hospital, index) => (
                  <div key={hospital["Hospital Name"]} className="hospital-top-item">
                    <span className="hospital-rank">#{index + 1}</span>
                    <div>
                      <strong>{hospital["Hospital Name"]}</strong>
                      <p>
                        {hospital.City} · {hospital.beds} beds
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </article>
          </section>

          <section className="hospital-controls-panel">
            <div className="hospital-search">
              <Search size={18} />
              <input
                type="text"
                placeholder="Search by hospital, city, owner, address..."
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
              />
            </div>

            <div className="hospital-filter-row">
              <label className="hospital-select-wrap">
                <Filter size={16} />
                <select
                  value={selectedOwner}
                  onChange={(event) => setSelectedOwner(event.target.value)}
                >
                  {ownerOptions.map((owner) => (
                    <option key={owner} value={owner}>
                      {owner === "All" ? "All Owners" : owner}
                    </option>
                  ))}
                </select>
              </label>

              <label className="hospital-select-wrap">
                <Building2 size={16} />
                <select
                  value={selectedCity}
                  onChange={(event) => setSelectedCity(event.target.value)}
                >
                  {cityOptions.map((city) => (
                    <option key={city} value={city}>
                      {city === "All" ? "All Cities" : city}
                    </option>
                  ))}
                </select>
              </label>

              <label className="hospital-select-wrap">
                <Users size={16} />
                <select
                  value={selectedBedSize}
                  onChange={(event) => setSelectedBedSize(event.target.value)}
                >
                  <option value="All">All Bed Sizes</option>
                  <option value="Small">Small Hospitals</option>
                  <option value="Medium">Medium Hospitals</option>
                  <option value="Large">Large Hospitals</option>
                </select>
              </label>

              <label className="hospital-select-wrap">
                <Filter size={16} />
                <select
                  value={sortBy}
                  onChange={(event) => setSortBy(event.target.value)}
                >
                  <option value="beds">Sort by Beds</option>
                  <option value="name">Sort by Name</option>
                  <option value="city">Sort by City</option>
                </select>
              </label>
            </div>
          </section>

          <section className="hospital-results-head">
            <div>
              <h2>Hospital Gallery</h2>
              <p>
                {filteredHospitals.length} hospitals match the current filters
                {filteredHospitals.length > 0 &&
                  ` • Showing ${visibleRangeStart}-${visibleRangeEnd}`}
              </p>
            </div>
            <button
              type="button"
              className="hospital-clear-btn"
              onClick={() => {
                setSearchQuery("");
                setSelectedOwner("All");
                setSelectedCity("All");
                setSelectedBedSize("All");
                setSortBy("beds");
              }}
            >
              Reset Filters
            </button>
          </section>

          <section className="hospital-card-grid">
            {paginatedHospitals.map((hospital) => (
              <article
                key={hospital["Hospital Name"]}
                className="hospital-directory-card"
              >
                <div className="hospital-card-image-wrap">
                  <img
                    src={hospital.Image}
                    alt={hospital["Hospital Name"]}
                    className="hospital-card-image"
                  />
                  <span className={`hospital-bed-badge ${hospital.bedSize.toLowerCase()}`}>
                    {hospital.beds} beds
                  </span>
                </div>

                <div className="hospital-card-body">
                  <div className="hospital-card-title-row">
                    <div>
                      <h3>{hospital["Hospital Name"]}</h3>
                      <p>{hospital.City}</p>
                    </div>
                    <span className="hospital-owner-pill">{hospital.Owner}</span>
                  </div>

                  <div className="hospital-card-meta">
                    <span>
                      <Phone size={15} /> {hospital["Phone No:"]}
                    </span>
                    <span>
                      <Building2 size={15} /> {hospital.bedSize} facility
                    </span>
                  </div>

                  <p className="hospital-card-address">{hospital.Address}</p>

                  <div className="hospital-card-actions">
                    <a
                      href={hospital.Website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hospital-primary-link"
                    >
                      Visit Website <ExternalLink size={15} />
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </section>

          {filteredHospitals.length > HOSPITALS_PER_PAGE && (
            <nav className="hospital-pagination" aria-label="Hospital pagination">
              <button
                type="button"
                className="hospital-page-btn"
                onClick={() => setCurrentPage((page) => Math.max(page - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              <div className="hospital-page-indicators">
                {Array.from({ length: totalPages }, (_, index) => {
                  const pageNumber = index + 1;

                  return (
                    <button
                      type="button"
                      key={pageNumber}
                      className={`hospital-page-btn hospital-page-number ${
                        currentPage === pageNumber ? "active" : ""
                      }`}
                      onClick={() => setCurrentPage(pageNumber)}
                      aria-current={currentPage === pageNumber ? "page" : undefined}
                    >
                      {pageNumber}
                    </button>
                  );
                })}
              </div>

              <button
                type="button"
                className="hospital-page-btn"
                onClick={() =>
                  setCurrentPage((page) => Math.min(page + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </nav>
          )}

          {filteredHospitals.length === 0 && (
            <div className="hospital-empty-state">
              <h3>No hospitals found</h3>
              <p>Try widening the search or clearing one of the active filters.</p>
            </div>
          )}
        </div>

        {/* Data Sources */}
        <div className="flex items-center justify-center mt-6">
          <div className="w-[95%] flex flex-col items-end gap-1">
            <span className="font-semibold text-sm text-gray-700">Data Sources:</span>
            <a
              href="https://www.ahd.com/states/hospital_UT.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
            >
              American Hospital Directory
            </a>
            <a
              href="https://en.wikipedia.org/wiki/List_of_hospitals_in_Utah"
              target="_blank"
              rel="noreferrer"
              className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
            >
              Wikipedia - List of Hospitals in Utah
            </a>
            <a
              href="https://www.causeiq.com/directory/hospitals-list/utah-state/#search_section"
              target="_blank"
              rel="noreferrer"
              className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
            >
              CauseIQ - Utah Hospitals Directory
            </a>
          </div>
        </div>

      {/* Footer */}
      <Footer />
    </div>
    </div>
  );
};

export default Hospital;
